import type { EditorCommand } from '@atlaskit/editor-common/types';
import type { Step } from '@atlaskit/editor-prosemirror/transform';

import { editorOfflineStoragePluginKey } from './main';

export function applyStepsCommand(steps: Step[]): EditorCommand {
	return ({ tr }) => {
		steps.forEach((step) => {
			try {
				tr.step(step);
			} catch (e) {
				// step failed to apply, ignore it and attempt to apply other steps
			}
		});
		tr.setMeta('addToHistory', false);
		tr.setMeta(editorOfflineStoragePluginKey, {
			status: 'ready',
		});
		return tr;
	};
}

export function tooManyRetriesCommand(): EditorCommand {
	return ({ tr }) => {
		tr.setMeta('addToHistory', false);
		tr.setMeta(editorOfflineStoragePluginKey, {
			status: 'tooManyRetries',
		});
		return tr;
	};
}

export function retryCommand(retryCount: number): EditorCommand {
	return ({ tr }) => {
		tr.setMeta('addToHistory', false);
		tr.setMeta(editorOfflineStoragePluginKey, {
			status: 'pending',
			retryCount: retryCount + 1,
		});
		return tr;
	};
}
